function r() {
  return [];
}
var t = r;
export {
  t as s
};
